import { AppRegistrationSection } from '../../AppRegistrationSection';
import { Card, Spacer, Text, Title } from 'components';
import { CheckmarkIcon, PhoneCallIcon } from 'components/icons';
import { Frame } from 'components/organisms';
import { frameConfig } from '../../AppConfig';
import { getScreenTranslation } from '../../utils/translations';
import { ROUTES } from 'utils/constants/constants_routes';
import { useMemo } from 'react';
import { usePayment } from '../../hooks/usePayment';
import { useTranslation } from 'react-i18next';
import ActivePayment from 'components/molecules/ActivePayment/ActivePayment';
import layout from 'scss/layout.module.scss';
import styles from './RequestSuccess.module.scss';

export default function RegistrationSuccess() {
  const i18Next = useTranslation();

  const { activateAutoRepay, showAutoPaymentSection } = usePayment({
    continueScreen: ROUTES.FIRST_LOAN_ONLINE_BANK_PENDING_WAITING,
  });

  const content = getScreenTranslation('registration_success', i18Next);

  const onActiveBtnHandler = showAutoPaymentSection
    ? activateAutoRepay
    : undefined;

  // TODO: Pending to enable the auto-repayment option. For now, it's only available in the screen "LoanApproved"
  const SecondCard = useMemo(
    () =>
      onActiveBtnHandler &&
      content.activateBtn &&
      content.messageSecondCard &&
      content.titleMessageSecondCard && (
        <Spacer marginBottom="30px" marginTop="-1px">
          <ActivePayment
            onActiveBtnHandler={onActiveBtnHandler}
            content={{
              activateBtn: content.activateBtn,
              message: content.messageSecondCard,
              title: content.titleMessageSecondCard,
            }}
            cardClassName={styles['request-success-card']}
            data-test="css-Autorepayment-Card"
          />
        </Spacer>
      ),
    [
      onActiveBtnHandler,
      content.activateBtn,
      content.messageSecondCard,
      content.titleMessageSecondCard,
    ],
  );
  return (
    <Frame
      {...frameConfig}
      hideEditButton={true}
      bodyWrapperClassName={layout['frame-x-compact']}
      sectionID={AppRegistrationSection.Summary}
    >
      <div className={layout['width-lg']}>
        <Spacer
          paddingHorizontal={{ s: '20px' }}
          marginBottom={{ default: '50px', s: '35px' }}
        >
          <Title
            icon={<CheckmarkIcon />}
            text={content.title}
            data-test="css-Title"
          />
        </Spacer>
        <Spacer marginBottom={{ default: '20px', s: '0px' }}>
          <Card className={styles['request-success-card']}>
            <Card className={styles['card-message']} intent="success">
              <Spacer
                padding={{ default: '25px 25px 31px', s: '28px 25px 31px' }}
              >
                <div
                  className={styles['title-message']}
                  data-test="css-Info-Container"
                >
                  <PhoneCallIcon />
                  <span>{content.titleMessageGreen}</span>
                </div>
                <Text level={2} text={content.messageGreen} />
              </Spacer>
            </Card>
          </Card>
        </Spacer>
        {onActiveBtnHandler && SecondCard}
      </div>
    </Frame>
  );
}
